<script>
import { mapState } from "vuex";

import * as api from "@/services/api.js";

export default {
  components: {},
  props: {},
  data: () => ({
    logoutLoading: false, //move button to component
  }),
  computed: {
    ...mapState({
      activeAccount: (state) => state.activeAccount,
      isAuth: (state) => state.isAuth,
    }),
  },
  methods: {
    async logout() {
      this.logoutLoading = true;
      const res = await api.get("auth/logout");
      console.log(res);
      this.logoutLoading = false;
      window.location.replace("/login");
    },
  },
  created() {},
  mounted() {},
};
</script>
<template>
  <v-app-bar app color="secondary" flat fixed class="app-bar mb-4">
    <router-link :to="isAuth ? '/' : '/login'" class="logo-link">
      <v-sheet class="d-flex align-center">
        <v-img
          alt="emeraldgreen logo"
          contain
          src="../assets/logo.png"
          class="logo"
        />
        <span class="subtext">SOLParser</span>
      </v-sheet>
    </router-link>
    <v-spacer></v-spacer>

    <v-sheet
      v-if="$route.name !== 'login' && isAuth"
      color="transparent"
      class="d-flex align-start"
    >
      <!-- <v-btn color="error" outlined small text to="/testing" class="mr-2"
        ><v-icon left small>mdi-alert-circle</v-icon>TEST</v-btn
      > -->
      <v-btn color="primary" outlined small text to="/api-explorer" class="mr-2"
        ><v-icon left small>mdi-tools</v-icon>API</v-btn
      >
      <v-menu
        bottom
        offset-y
        return-value="id"
        transition="slide-y-transition"
        width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-card v-bind="attrs" v-on="on" flat>
            <v-card-text
              class="d-flex align-center justify-space-between primary--text pa-0"
            >
              <v-icon color="primary" class="mr-0 mr-sm-2"
                >mdi-account-circle</v-icon
              >
              <p class="d-none d-sm-flex mb-0">{{ activeAccount?.username }}</p>
              <v-icon color="primary" class="ml-1">mdi-menu-down</v-icon>
            </v-card-text>
          </v-card>
        </template>
        <v-list class="text-left">
          <v-list-item exact to="/account">
            <v-list-item-content>
              <v-list-item-title
                v-text="'ACCOUNT SETTINGS'"
                class="primary--text text-body-1 font-weight-bold text-no-wrap"
              ></v-list-item-title>
              <v-list-item-subtitle
                v-text="'Account details and settings'"
              ></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="primary" disabled>mdi-account-cog</v-icon>
            </v-list-item-action>
            <!-- <p class="primary--text text-body-1 font-weight-bold text-no-wrap mb-n1">{{  }}</p> -->
            <!-- <p class="text-body-2 text-no-wrap font-italic mb-0">{{  }}</p> -->
          </v-list-item>
          <v-list-item exact to="/account/trailers">
            <v-list-item-content>
              <v-list-item-title
                v-text="'MANAGE TRAILERS'"
                class="primary--text text-body-1 font-weight-bold text-no-wrap"
              ></v-list-item-title>
              <v-list-item-subtitle
                v-text="'Trailer mappings and settings'"
              ></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="primary">mdi-truck-trailer</v-icon>
            </v-list-item-action>
            <!-- <p class="primary--text text-body-1 font-weight-bold text-no-wrap mb-n1">{{  }}</p> -->
            <!-- <p class="text-body-2 text-no-wrap font-italic mb-0">{{  }}</p> -->
          </v-list-item>
          <v-divider class="my-4"></v-divider>
          <v-list-item hover @click="logout">
            <v-list-item-action>
              <v-icon color="primary">mdi-logout-variant</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                v-text="'LOGOUT'"
                class="primary--text text-body-1 font-weight-bold text-no-wrap"
              ></v-list-item-title>
              <v-list-item-subtitle
                v-text="activeAccount?.username"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- <v-btn  color="primary" :loading="logoutLoading" text @click="logout" class="ml-auto"
        ><v-icon left>mdi-account-arrow-right</v-icon><span class="font-weight-bold">LOGOUT</span></v-btn
      >
      <p class="accent--text mb-n1">{{ $store?.state?.activeAccount?.username || '' }}</p> -->
    </v-sheet>
  </v-app-bar>
</template>

<style scoped>
>>> .v-toolbar__content {
  max-width: 1400px;
  margin-inline: auto;
}
.app-bar {
  z-index: 20;
}
.logo-link {
  text-decoration: none;
}
</style>
